import { render } from "./ProductPackage.vue?vue&type=template&id=0f2364d8"
import script from "./ProductPackage.vue?vue&type=script&lang=js"
export * from "./ProductPackage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__